import toDate from 'date-fns-tz/toDate';
import { DEFAULT_TIME_FORMAT } from './constants.js';
import { fastParse } from './fastParse.js';
export const DAY_DURATION_IN_MINUTES = 24 * 60;
export const MIDNIGHT = '12:00 AM';
// Use a fixed date that is not affected by Daylight Saving Time (DST) transitions.
const dateAnchor = toDate('2016-04-15 00:00:00', { timeZone: 'UTC' });
export const timeToMinuteDuration = (timeText) => {
    const date = fastParse(timeText, DEFAULT_TIME_FORMAT, dateAnchor);
    return date.getHours() * 60 + date.getMinutes();
};
/**
 * Calculates the number of minutes between the provided time and the next/future midnight.
 * @param time
 * @returns Number of minutes from midnight.
 */
export const timeToMinuteDurationFromMidnight = (time) => {
    if (time === MIDNIGHT) {
        return 0;
    }
    const minutes = timeToMinuteDuration(time);
    return DAY_DURATION_IN_MINUTES - minutes;
};
export const minuteDurationToTime = (durationMins) => {
    // Special case for all day
    if (durationMins === DAY_DURATION_IN_MINUTES) {
        return MIDNIGHT;
    }
    // Special case for negative durations
    if (durationMins < 0) {
        durationMins = DAY_DURATION_IN_MINUTES + durationMins;
    }
    // Special case for greater than a day
    durationMins %= DAY_DURATION_IN_MINUTES;
    const hours24 = Math.floor(durationMins / 60);
    const hours12 = hours24 > 12 ? hours24 - 12 : hours24;
    const hoursFormatted = hours12 === 0 ? '12' : hours12;
    const minutes = durationMins % 60;
    const minutesFormatted = String(minutes).padStart(2, '0');
    const meridian = hours24 >= 12 ? 'PM' : 'AM';
    return `${hoursFormatted}:${minutesFormatted} ${meridian}`;
};
export const twentyFourHourToTime = (hhmm) => {
    const match = /^(\d{1,2}):(\d{2})$/.exec(hhmm.trim());
    if (!match)
        return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 24 || minutes > 59)
        return null;
    if (hours === 24 && minutes !== 0)
        return null;
    return minuteDurationToTime(hours * 60 + minutes);
};
export const is24Hours = (hours) => {
    return (!hours.length || (hours[0].start === MIDNIGHT && hours[0].end === MIDNIGHT));
};
export const normalizeTime = (value) => {
    if (value.startsWith('0')) {
        return value.slice(1);
    }
    return value;
};
//# sourceMappingURL=timeText.js.map